<template>
    <v-dialog
    v-model="show"
    persistent
    width="300">
   
    <v-card color="light_gray">
        <v-toolbar class="mid-font" color="primary" dense dark >
            <v-icon left >mdi-cash</v-icon><span class="va-underline">Add Load</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
          <v-card-text class="pa-4 def-font">
               <v-form
                ref="form"
                v-model="valid"
                autocomplete="off"
                lazy-validation>
                <v-text-field 
                type="number"
                    v-model="entry.amount"
                    label="Enter Amount"
                    large
                    outlined
                    :rules="nameRules"
                    @focus="revalidate=false"
                    required
                    append-outer-icon="mdi-send"
                    @click:append-outer="revalidate=true"
                />
                    <v-text-field 
                    v-if="revalidate"
                type="number"
                large
                    v-model="amount"
                    label="Re-Enter Amount"
                    outlined
                />
                <v-divider/>

                 <v-text-field 
                    v-if="$IsNum(amount) == $IsNum(entry.amount) && $IsNum(amount)  && $IsNum(entry.amount)"
                    dense
                    v-model="val_text"
                    label="Type 'Add Load' on the field"
                    outlined
                />
                
               </v-form>
               <v-divider/>
          </v-card-text>
          <v-card-actions>
              <v-spacer/>
              <template v-if="verified">
              <v-btn small color="secondary" @click="validate()">
                 Load
              </v-btn>
              </template>
          </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
      show:{
          type: Boolean,
          default: false
      },
      account: {
          type: Object,
          default: ()=>{return {}}
      } 
  },
  data () {
      return {
          valid: true,
          revalidate: false,
          val_text:"",
          entry:{},
          amount: null,
           nameRules: [
            v => !!v || '*Required'
        ],
      }
    },
  watch: {
     show(val) {
         if(val) {
             this.entry = {}
             this.revalidate = false
             this.val_text = ''
         }
     }
  },
  computed:{
      verified() {
          if(this.$IsNum(this.entry.amount) == 0 || this.val_text !='Add Load') {
                return false
          }
          return this.$IsNum(this.entry.amount) == this.$IsNum(this.amount)?true:false
      }
  },
  methods: {
   emitToParent (action) {
      this.$emit('DialogEvent',action)
    },
    validate(){
        if (this.$refs.form.validate()) {
           this.Load()
        }
    },
    Load(){
        this.entry.type = "Add Load"
        this.entry.description = "Add Load"
        this.entry.amount = this.$IsNum(this.entry.amount)
        this.entry.account = this.account.id
        console.log(this.entry)
           this.$emit('DialogEvent',this.entry)
    }
  }
}
</script>
